<template>
  <div class="pagination-wrapper">
    <v-pagination
      v-model="source.current_page"
      :length="source.last_page"
      :total-visible="7"
      light
      prev-icon="mdi-chevron-left"
      next-icon="mdi-chevron-right"
      @input="next"
    />
  </div>
</template>
<script>
export default {
  props: ["source"],
  data() {
    return {
      pages: [],
    };
  },
  watch: {
    source() {
     
    },
  },
  methods: {
    next(page) {
    //  console.log(page)
    this.$emit('navigate', page)
  
    },
  },
};
</script>
<style scoped>
.pagination-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  font-family: 'Inter', sans-serif;
}

.pagination-wrapper >>> .v-pagination {
  margin: 0;
}

.pagination-wrapper >>> .v-pagination .v-pagination__item,
.pagination-wrapper >>> .v-pagination .v-pagination__navigation {
  box-shadow: none !important;
  border: 1px solid #e0e0e0 !important;
  border-radius: 4px !important;
  min-width: 32px !important;
  height: 32px !important;
  font-family: 'Inter', sans-serif !important;
  font-size: 13px !important;
}

.pagination-wrapper >>> .v-pagination .v-pagination__item--active {
  background-color: #212121 !important;
  border-color: #212121 !important;
  color: white !important;
}

.pagination-wrapper >>> .v-pagination .v-pagination__navigation .v-icon {
  font-size: 18px;
}
</style>


